import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";
import { Error } from "../common/Error";
import { CommissionModel } from "../../domain/CommissionModel";
import { Grid } from "@material-ui/core";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { ExperimentalFeature } from "@ofqual/portal-components/components/ExperimentalFeature";
import { useAuth } from "@ofqual/portal-core/core/hooks";
import { authSelector } from "../../redux/selectors";


export const CommissionFinancial: React.FC<{
    sectionProps: SectionProps<CommissionModel>;
}> = ({ sectionProps }) => {
    const { control, errors, editable } = sectionProps;
    const readOnly: boolean | undefined = editable ? false : true;

    const { experimentalFeatures } = useAuth(authSelector);


    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Controller
                    control={control}
                    name="rateOfPay"
                    rules={{
                        required: false,
                        maxLength: 9,
                    }}
                    as={
                        <TextField
                            variant="outlined"
                            label="Rate of pay"
                            data-test="commission-rateOfPay"
                            fullWidth
                            readOnly={readOnly}
                            inputProps={{
                                type: "number",
                                step: "0.01",
                                min: "0",
                            }}
                        />
                    }
                />
                {errors.rateOfPay?.type === "maxLength" && (
                    <Error data-test="error-rate-of-pay-field-max-length">Rate of pay must be less than 10 integers</Error>
                )}
            </Grid>

            <Grid item xs={12}>
                <Controller
                    control={control}
                    name="purchaseOrderNumber"
                    rules={{
                        required: false,
                        maxLength: 15,
                    }}
                    as={
                        <TextField
                            variant="outlined"
                            label="Purchase Order (PO) number"
                            data-test="commission-purchaseOrderNumber"
                            multiline
                            fullWidth
                            readOnly={readOnly}
                        />
                    }
                />
                {errors.purchaseOrderNumber?.type === "maxLength" && (
                    <Error data-test="error-purchase-order-number-field-max-length">Purchase Order Number must be less than 16 characters</Error>
                )}
            </Grid>

            <ExperimentalFeature
                experimentalModuleName="portal-commissions"
                experimentalFeatures={experimentalFeatures}
                experimentalFeatureVisibleName="portal-commissions-close">
                <Grid item xs={12}>
                    <Controller
                        control={control}
                        name="actualCost"
                        rules={{
                            maxLength: 9,
                        }}
                        as={
                            <TextField
                                variant="outlined"
                                label="Actual cost"
                                data-test="commission-actualCost"
                                fullWidth
                                readOnly={readOnly}
                                inputProps={{
                                    type: "number",
                                    step: "0.01",
                                    min: "0",
                                }}
                            />
                        }
                    />
                    {errors.actualCost?.type === "maxLength" && (
                        <Error data-test="error-actual-cost-field-max-length">Actual cost must be less than 10 characters</Error>
                    )}
                    {errors.actualCost?.type === "custom" && (
                        <Error data-test="error-actual-cost-field-required">Actual cost is required</Error>
                    )}
                </Grid>
            </ExperimentalFeature>

            <ExperimentalFeature
                experimentalModuleName="portal-commissions"
                experimentalFeatures={experimentalFeatures}
                experimentalFeatureVisibleName="portal-commissions-close">
            
                <Grid item xs={12}>
                    <Controller
                        control={control}
                        name="actualNumDaysWorked"
                        rules={{
                            maxLength: 5,
                        }}
                        as={
                            <TextField
                                variant="outlined"
                                label="Actual number of days worked"
                                data-test="commission-actualNumOfDaysWorked"
                                fullWidth
                                readOnly={readOnly}
                                inputProps={{
                                    type: "number",
                                    step: "0.01",
                                    min: "0",
                                }}
                            />
                        }
                    />
                    {errors.actualNumDaysWorked?.type === "maxLength" && (
                        <Error data-test="error-actual-number-of-days-worked-field-max-length">Actual number of days worked must be less than 5 characters</Error>
                    )}
                    {errors.actualNumDaysWorked?.type === "custom" && (
                        <Error data-test="error-actual-number-of-days-worked-field-required">Actual number of days worked is required</Error>
                    )}
                </Grid>
            </ExperimentalFeature>
        </Grid>
    );
};